var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.header,attrs:{"name":"logo"}},[_c('div',{class:_vm.$style.headerIcon},[_c('icon',{attrs:{"name":"openai","color":"white","width":"27","height":"27"}})],1),_vm._v(" "+_vm._s(_vm.$t('gpt.introduction.headerText'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }